import { API } from '../constants/constants';

export const getMonthlyInteractions = async (
  month: string,
  timezoneOffset: string,
  isCalendarEvent: boolean = false
) => {
  const res = await API.get(`/issues/monthly`, {
    params: {
      month,
      timezoneOffset,
      isCalendarEvent,
    },
  });
  return res.data;
};

export const createInteraction = async (data: any) => {
  const res = await API.post(`/issue`, data);
  return res.data;
};

export const updateInteractionWithFiles = async (data: any) => {
  const { id, fields, uploadingUrls, removingUrls } = data;
  const res = await API.put(`/issues/${id}/update`, {
    urls: uploadingUrls,
    deletingUrls: removingUrls,
    fields,
  });

  return res.data;
};

export const deleteInteraction = async (id: string) => {
  const res = await API.delete(`/issue/${id}`);
  return res.data;
};

export const getFilteredInteractions = async (filterQueryString: string) => {
  const res = await API.get(`issues/filter?${filterQueryString}`);
  return res.data?.data;
};

export const getFuzzySearchInteractions = async (queryString: string, category: string) => {
  const res = await API.get(`/issues/fuzzySearch?queryString=${queryString}&category=${category}`);
  return res.data?.data;
};
